module.exports = __webpack_public_path__ + "static/img/icon_robot_big.5344a849.png";